import { SubmissionExpiringPolicyData } from '@common/types';
import { flushSync } from 'react-dom';
import { UseFormReturn } from 'react-hook-form';
import { Button, Stack } from '@common-components';
import { messages } from 'i18n';
import { InnerPageProps } from 'broker/pages/SubmissionWorkspacePage/components/InnerPage/types';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';
import { ExpiringPolicyFormData } from './utils';

interface ExpiringPolicyFooterProps extends InnerPageProps {
  isSubmitting: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
  setIsDirty: (isDirty: boolean) => void;
  methods: UseFormReturn<ExpiringPolicyFormData>;
}

export function ExpiringPolicyFooter({
  onClose,
  isSubmitting,
  setIsSubmitting,
  setIsDirty,
  methods,
}: ExpiringPolicyFooterProps) {
  const { partialSubmission, updateSubmission } = useSubmissionsWorkspace();

  const handleSave = async (formData: ExpiringPolicyFormData) => {
    setIsSubmitting(true);
    try {
      const submissionData: SubmissionExpiringPolicyData = {
        ...formData,
        premium: formData.premium ? Number(formData.premium) : undefined,
        aggregateLimit: formData.aggregateLimit ? Number(formData.aggregateLimit) : undefined,
        perOccurrenceLimit: formData.perOccurrenceLimit ? Number(formData.perOccurrenceLimit) : undefined,
        deductibles: formData.deductibles ? Number(formData.deductibles) : undefined,
      };

      const updatedData = {
        // save button is disabled if partialSubmission is null
        ...partialSubmission!.additionalData,
        expiringPolicyData: [submissionData],
      };

      await updateSubmission(partialSubmission!.id, {
        additionalData: updatedData,
      });

      // Force React to flush the dirty flag update before we navigate away
      flushSync(() => {
        setIsDirty(false);
      });
      onClose();
    } catch (e) {
      setIsDirty(false);
      throw e;
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Stack direction="row" justifyContent="flex-end">
      <Button
        variant="contained"
        onClick={methods.handleSubmit(handleSave)}
        disabled={!partialSubmission}
        loading={isSubmitting}
      >
        {messages.buttons.save}
      </Button>
    </Stack>
  );
}
